import { Form as AntForm, Checkbox } from 'antd';
import { AnySchema } from 'yup';
import { Controller, Control } from 'react-hook-form';
import { formHelpers } from '@helpers/formHelpers';

const { Item: FormItem } = AntForm;

interface HSMSCheckBoxOption {
  label: string;
  value: string;
}

interface HSMSCheckBoxProps {
  label: string;
  name: string;
  isRequiredOptional?: boolean; // If we need to set manually required state of field
  checkBoxOptions: HSMSCheckBoxOption[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: AnySchema;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
}

export const HSMSCheckBoxGroup = ({
  label,
  name,
  checkBoxOptions,
  control,
  validationSchema,
  errors,
  isRequiredOptional,
}: HSMSCheckBoxProps) => (
  <FormItem
    label={label}
    required={(validationSchema && formHelpers.isRequired(validationSchema, name)) || isRequiredOptional}
    validateStatus={errors && errors[name] ? 'error' : ''}
    help={errors && errors[name]?.message}
    labelCol={{ span: 24 }}
  >
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => {
        return (
          <Checkbox.Group onChange={onChange} value={value}>
            {checkBoxOptions.map((checkBoxOption) => (
              <Checkbox key={checkBoxOption.value} value={checkBoxOption.value}>
                {checkBoxOption.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        );
      }}
    />
  </FormItem>
);
